import { Card, Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import { EpidemiologyCaseForm058E_NotificationSection } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearHourMinutesFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  notification: EpidemiologyCaseForm058E_NotificationSection
}

export const EpidemiologyNotificationDetailsCard = ({
  notification
}: Props) => {
  const { t, currentLang } = useLocales()

  return (
    <Card title={t('epidemiology.notification')}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.epidemiology_number')}</Text>
            <Text weight={400}>{notification.epidemiologyNumber || '-'}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.institution_that_notified')}</Text>
            <Text weight={400}>{notification.institution?.title || '-'}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('organizational_structure.institution_code')}</Text>
            <Text weight={400}>{notification.institution?.code || '-'}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.institution_classification')}</Text>
            <Text weight={400}>
              {notification.institution?.medicalAssistanceType
                ? t(
                    `medical_assistance.${notification.institution?.medicalAssistanceType}`
                  )
                : '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>
              {t('organizational_structure.institution_classification')}
            </Text>
            <Text weight={400}>
              {notification.institution?.classification?.name?.[
                currentLang.value
              ] || '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.city')}</Text>
            <Text weight={400}>
              {notification.institution?.address?.locality || '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('organizational_structure.city')}</Text>
            <Text weight={400}>
              {notification?.institution?.address?.cuatmLocality?.translation?.[
                currentLang.value
              ] || '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('common.phone')}</Text>
            <Text weight={400}>
              {notification.institution?.phoneNumber || '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.person_who_notified')}</Text>
            <Text weight={400}>{notification.notifierFullName || '-'}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.notification_date_time')}</Text>
            <Text weight={400}>
              {notification.notifiedAt
                ? dayjs(notification.notifiedAt).format(
                    dayMonthYearHourMinutesFormatWithDot
                  )
                : '-'}
            </Text>
          </Flex>
        </Col>
      </Row>
    </Card>
  )
}
